import { render, staticRenderFns } from "./Actualite.vue?vue&type=template&id=26995214&scoped=true&"
import script from "./Actualite.vue?vue&type=script&lang=js&"
export * from "./Actualite.vue?vue&type=script&lang=js&"
import style0 from "./Actualite.vue?vue&type=style&index=0&id=26995214&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26995214",
  null
  
)

export default component.exports